import { render } from "./DataExport.vue?vue&type=template&id=f777714a"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"
script.render = render

export default script